<template>
    <div class="cell-buttons-wrapper">
      <div class="cell-buttons">
        <a
          :href="href || '#'"
          :target="href ? '_blank' : ''"
          class="cell-button"
          :class="{'disabled': !href}"
        >
          <vs-button
              size="small"
              :color="borderColour"
              type="border"
              :disabled="!href"
              :style="`background:${backgroundColour} !important`"
          >
            <span :style="`color:${fontColour}`">{{ $t(buttonTxt) }}</span>
          </vs-button>
        </a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererButton',
  computed: {
    backgroundColour() {
      return this.params.backGroundColour || 'transparent';
    },
    borderColour() {
      return this.params.borderColour || 'black';
    },
    fontColour() {
      return this.params.fontColour || 'black';
    },
    buttonTxt() {
      return this.params.buttonTxt;
    },
    column() {
      return this.params.column;
    },
    href() {
      return this.params.data[this.column];
    },
  },
}
</script>

<style lang="scss">
  @import '@/assets/scss/custom/components/variables';
  .cell-buttons-wrapper {
    height: 100%;
    display: flex;
    align-items: center;

    .cell-buttons {
      .cell-button {
        &.disabled {
          cursor: initial;
        }

        > button:hover {
          background-color: #fff !important;
        }  
      }

      button {
        padding: 2.5px 7px !important;

        span {
          font-size: 12px;
        }
      }
    }
  }
</style>
